import { render, staticRenderFns } from "./MaterialEditPage.vue?vue&type=template&id=31075fa4&scoped=true"
import script from "./MaterialEditPage.vue?vue&type=script&lang=ts"
export * from "./MaterialEditPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialEditPage.vue?vue&type=style&index=0&id=31075fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31075fa4",
  null
  
)

export default component.exports